module.exports = __webpack_public_path__ + "static/media/stage-4.73ea45f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/DevelopingABrandCharacter/stage-4.jpg
// module id = 413
// module chunks = 0